// 模拟博客数据
export const mockPosts = [
  {
    id: 1,
    title: 'React Hooks 完全指南',
    summary: '深入学习React Hooks的使用方法和最佳实践，包括useState、useEffect、useContext等核心Hook的详细解析。',
    content: `# React Hooks 完全指南

## 什么是Hooks？
React Hooks 是 React 16.8 的新增特性。它可以让你在不编写 class 的情况下使用 state 以及其他的 React 特性。

## 为什么要用Hooks？
- **代码更简洁**：无需编写 class 组件
- **逻辑复用更简单**：可以使用自定义 Hook 复用状态逻辑
- **学习成本更低**：不需要理解 this 的工作方式

## 常用的Hooks

### 1. useState
\`\`\`javascript
import React, { useState } from 'react';

function Example() {
  const [count, setCount] = useState(0);

  return (
    <div>
      <p>You clicked {count} times</p>
      <button onClick={() => setCount(count + 1)}>
        Click me
      </button>
    </div>
  );
}
\`\`\`

### 2. useEffect
用于处理副作用，如数据获取、订阅等。

### 3. useContext
让你能够在组件树中传递数据而无需手动传递 props。

## 最佳实践
1. 只在最顶层使用 Hook
2. 只在 React 函数中调用 Hook
3. 使用 eslint-plugin-react-hooks 插件

> 学习Hooks是掌握现代React开发的关键！`,
    coverImage: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=400&fit=crop',
    author: '张三',
    tags: ['React', 'JavaScript', '前端', 'Hooks'],
    category: '前端开发',
    viewCount: 1250,
    likeCount: 85,
    commentCount: 24,
    createdAt: '2023-10-15T10:30:00Z',
    updatedAt: '2023-10-16T14:20:00Z'
  },
  {
    id: 2,
    title: 'Node.js 性能优化实战',
    summary: '分享Node.js应用中常见的性能问题和解决方案，包括内存泄漏、CPU密集型任务处理等。',
    content: '这里是完整的Node.js性能优化内容...',
    coverImage: 'https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=800&h=400&fit=crop',
    author: '李四',
    tags: ['Node.js', '后端', '性能优化'],
    category: '后端技术',
    viewCount: 980,
    likeCount: 72,
    commentCount: 18,
    createdAt: '2023-10-10T14:45:00Z',
    updatedAt: '2023-10-12T09:15:00Z'
  },
  {
    id: 3,
    title: '使用Docker部署微服务',
    summary: '详细讲解如何使用Docker容器化技术来部署和管理微服务架构的应用。',
    content: '这里是完整的Docker部署内容...',
    coverImage: 'https://images.unsplash.com/photo-1589652717521-10c0d092dea9?w=800&h=400&fit=crop',
    author: '王五',
    tags: ['Docker', '微服务', 'DevOps'],
    category: '运维部署',
    viewCount: 1560,
    likeCount: 92,
    commentCount: 31,
    createdAt: '2023-10-05T09:20:00Z',
    updatedAt: '2023-10-08T16:30:00Z'
  },
  {
    id: 4,
    title: 'TypeScript 类型体操入门',
    summary: '探索TypeScript高级类型编程，让你的类型系统更加强大和灵活。',
    content: '这里是完整的TypeScript内容...',
    coverImage: 'https://images.unsplash.com/photo-1633356122102-3fe601e05bd2?w=800&h=400&fit=crop',
    author: '赵六',
    tags: ['TypeScript', '前端', '编程'],
    category: '前端开发',
    viewCount: 890,
    likeCount: 65,
    commentCount: 22,
    createdAt: '2023-09-28T11:10:00Z',
    updatedAt: '2023-09-30T13:45:00Z'
  },
  {
    id: 5,
    title: '机器学习基础：线性回归',
    summary: '从零开始学习机器学习的基础算法——线性回归，包含数学原理和代码实现。',
    content: '这里是完整的机器学习内容...',
    coverImage: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800&h=400&fit=crop',
    author: '孙七',
    tags: ['机器学习', '人工智能', 'Python'],
    category: '人工智能',
    viewCount: 1120,
    likeCount: 78,
    commentCount: 19,
    createdAt: '2023-09-20T15:30:00Z',
    updatedAt: '2023-09-25T10:20:00Z'
  },
  {
    id: 6,
    title: 'Vue 3 Composition API 深度解析',
    summary: '深入理解Vue 3的Composition API，学习如何更好地组织和复用代码逻辑。',
    content: '这里是完整的Vue 3内容...',
    coverImage: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=400&fit=crop',
    author: '周八',
    tags: ['Vue', 'JavaScript', '前端'],
    category: '前端开发',
    viewCount: 1340,
    likeCount: 81,
    commentCount: 27,
    createdAt: '2023-09-15T08:45:00Z',
    updatedAt: '2023-09-18T14:10:00Z'
  }
];

// 分类数据
export const categories = [
  { id: 1, name: '前端开发', count: 24 },
  { id: 2, name: '后端技术', count: 18 },
  { id: 3, name: '人工智能', count: 12 },
  { id: 4, name: '数据库', count: 15 },
  { id: 5, name: '运维部署', count: 8 },
  { id: 6, name: '生活随笔', count: 36 }
];

// 标签数据
export const tags = [
  { id: 1, name: 'React', count: 15 },
  { id: 2, name: 'Vue', count: 12 },
  { id: 3, name: 'Node.js', count: 10 },
  { id: 4, name: 'Python', count: 8 },
  { id: 5, name: 'Docker', count: 6 },
  { id: 6, name: 'TypeScript', count: 9 },
  { id: 7, name: 'JavaScript', count: 20 },
  { id: 8, name: 'CSS', count: 14 }
];

// 归档数据（按月份分组）
export const archives = [
  { year: 2023, month: 10, count: 12 },
  { year: 2023, month: 9, count: 18 },
  { year: 2023, month: 8, count: 15 },
  { year: 2023, month: 7, count: 9 },
  { year: 2023, month: 6, count: 11 }
];

// 模拟API函数
export const api = {
  // 获取文章列表
  getPosts: (page = 1, pageSize = 6) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const start = (page - 1) * pageSize;
        const end = start + pageSize;
        const data = mockPosts.slice(start, end);
        resolve({
          data,
          total: mockPosts.length,
          page,
          pageSize,
          totalPages: Math.ceil(mockPosts.length / pageSize)
        });
      }, 500);
    });
  },

  // 获取单篇文章
  getPost: (id) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const post = mockPosts.find(p => p.id === parseInt(id));
        if (post) {
          resolve(post);
        } else {
          reject(new Error('文章不存在'));
        }
      }, 300);
    });
  },

  // 获取分类
  getCategories: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(categories);
      }, 200);
    });
  },

  // 获取标签
  getTags: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(tags);
      }, 200);
    });
  },

  // 获取归档
  getArchives: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(archives);
      }, 200);
    });
  }
};